// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","blockAnimation":"Loader_blockAnimation__6Orfu","loaderProgress":"Loader_loaderProgress__QPI6H","progressAnimation":"Loader_progressAnimation__fBY3K"};